// extracted by mini-css-extract-plugin
module.exports = {"summaryContainerBlock":"styles_summaryContainerBlock__jozf1","mainLabel":"styles_mainLabel__21pxl","secondaryLabel":"styles_secondaryLabel__3xE4E"};